export default __webpack_public_path__ + "static/our-values-4-73553495f6d2e5f782ed6fb62a8c80ee.svg";